import { ORG_ADMIN_ONLY_QUICK_LAUNCH } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useOrgAdminOnlyQuickLaunch() {
  return useIsFeatureEnabled(ORG_ADMIN_ONLY_QUICK_LAUNCH);
}
